import 'moment/locale/pt';

import { DatePicker, Row } from 'antd';
import moment from 'moment';
import React from 'react';


const { RangePicker } = DatePicker;

type PropsType = {
    title?: string;
    onChange: any;
    format?: string;
    placeHolder: any;
    locale?: any;
    onOk: any;
    width?: string;
};

//FIXME: this component is weird
class RangePickerComponent extends React.Component<PropsType> {


    changeLocale(locale: any) {
        moment.locale((locale == "pt") ? "pt" : "en");
    }

    onDateChange = async (dates: any[], dateStrings: string[], onDateChangeCallback: any) => {
        try {
            const fromDate = dates[0].toDate();
            const toDate = dates[1].toDate();
            const datesInMilliseconds = [fromDate.getTime(), toDate.getTime()];

            onDateChangeCallback(datesInMilliseconds);
        } catch (error) {
            console.error("Date Error: ", error.message);
        }
    }

    render() {
        const {
            onChange,
            format,
            placeHolder,
            onOk,
            locale,
            width
        } = this.props;

        return (

            <div>
                {
                    this.changeLocale(locale)
                }
                <Row>
                    {this.props.title != undefined && (
                        <Row>
                            <p>{this.props.title}</p>
                        </Row>
                    )}
                    <RangePicker
                        showTime={{ format: 'HH:mm' }}
                        format={format}
                        placeholder={placeHolder}
                        onChange={onChange}
                        locale={locale}
                        onOk={onOk}
                        style={{ width: width }}
                    />
                </Row>
            </div>
        )
    }
}


export default RangePickerComponent;